export const AuthPageStrings = {
    DONT_HAVE_ACCOUNT: "Don't have an account? ",
    SIGN_UP: "Sign Up",
    ALREADY_HAVE_ACCOUNT: "Already have an account? ",
    LOGIN: "Login",
    NEED_PASSWORD_RECOVERY: "Need to recover your password? ",
    RECOVER: "Need to recover your password?"
};
